module.exports = __webpack_public_path__ + "img/1@xs.8a10ac6c.jpg";